<template>
  <v-card
  class="white rounded-lg"
  min-width="300"
  min-height="300"
  flat
  >
    <v-card-title class="secondary--text">
      نمودار هزینه ها
      <v-spacer></v-spacer>
    </v-card-title>
    <v-simple-table class="rounded-lg pl-2 pr-2 pb-2">
      <template v-slot:default>
        <thead class="back rounded-lg">
        <tr class="text-center">
          <td> عنوان حساب کل</td>
          <td>مبلغ کل</td>
          <td colspan="2">نمودار</td>
        </tr>
        </thead>
        <tbody>
        <tr class="text-center">
          <td>عنوان</td>
          <td>مبلغ</td>
          <td colspan="2" @click="chart_dialog = true">
            <cost-table-summary-chart :chart_value="[0, 2, 5, 9, 5, 10, 3, 5, -4, -10, 1]"></cost-table-summary-chart>
          </td>
        </tr>
        <tr class="text-center">
          <td>عنوان</td>
          <td>مبلغ</td>
          <td colspan="2">
            <cost-table-summary-chart :chart_value="[5, 2, 4, 6, -4, -6, 5, 8, 2, 5, 6]"></cost-table-summary-chart>
          </td>
        </tr>
        <tr class="text-center">
          <td>عنوان</td>
          <td>مبلغ</td>
          <td colspan="2">
            <cost-table-summary-chart :chart_value="[5, 2, 4, 6, 4, 3, 5, 5, 3, 1, -3]"></cost-table-summary-chart>
          </td>
        </tr>
        <tr class="text-center">
          <td>عنوان</td>
          <td >مبلغ</td>
          <td colspan="2">
            <cost-table-summary-chart :chart_value="[1, 2, 3, 6, -2, -1, 7, 8, 9, 10, 9]"></cost-table-summary-chart>
          </td>
        </tr>
        <tr class="text-center">
          <td>عنوان</td>
          <td>مبلغ</td>
          <td colspan="2" @click="chart_dialog = true">
            <cost-table-summary-chart :chart_value="[0, 2, 5, 9, 5, 10, 3, 5, -4, -10, 1]"></cost-table-summary-chart>
          </td>
        </tr>

        </tbody>
      </template>
    </v-simple-table>

  </v-card>

</template>

<script>
import CostTableSummaryChart from "@/views/reports/CostTableSummaryChart";
export default {
  name: "CostTable",
  components: {
    CostTableSummaryChart
  },
  props: {
    id: {},
  },
  data() {
    return {
      worshopId: 0,
      appendSlash: true,
      hasList: false,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      factors: [],
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      chart_dialog: false,
    };
  },
  computed: {
    headers() {
      return [];
    },
  },
  updated() {
  },
  methods: {

  }

}
</script>

<style scoped lang="scss"></style>

